export default "__VITE_ASSET__DrTLNpZ6__"